import React from 'react';

const LoadingSpinner: React.FC<{ message?: string }> = ({ message = 'Gleaning wisdom...' }) => (
  <div className="loading-container">
    <div className="mystical-loader"></div>
    <p style={{ color: 'var(--gold)', fontStyle: 'italic', letterSpacing: '1px' }}>{message}</p>
  </div>
);

export default LoadingSpinner;
